import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Form, Input, InputNumber, message, Modal } from 'antd'
import { useState } from 'react'

import { AppAdmin } from 'api/app-admin'
import ProtectedButton from 'component/button/protected-button'
import { FEATURE } from 'constants/feature'
import { useVestingContext } from 'context/vesting-context-provider'
import { isValidETHAddress } from 'utils/validate-fields'

interface IButtonCreate {
  onSubmit?: () => void
}

const ButtonCreate = ({ onSubmit }: IButtonCreate) => {
  const { type } = useVestingContext()

  const [openModal, setOpenModal] = useState(false)

  const [form] = Form.useForm()

  const [messageApi, contextHolder] = message.useMessage()

  const handleOk = () => {
    form
      .validateFields()
      .then(async (values: any) => {
        const { ...createData } = values
        const response = await AppAdmin.createUserVesting(createData)
        setOpenModal(false)
        messageApi.open({
          type: 'success',
          content: response.data.message,
        })
        onSubmit?.()
      })
      .catch((error: any) => {
        setOpenModal(false)
        messageApi.open({
          type: 'error',
          content: error.message ? error.message : error.errorFields[0].errors[0],
        })
        // Error message format = "[errorField] [reason]"
        if (error && error.message) {
          form.setFields([
            {
              name: error.message.split(' ')[0],
              errors: [error.message],
            },
          ])
        }
      })
  }

  const handleCancel = () => {
    setOpenModal(false)
    form.resetFields()
  }

  return (
    <>
      {contextHolder}
      <ProtectedButton
        color="primary"
        variant="solid"
        type="primary"
        feature={FEATURE.VESTING}
        requireCRUD
        onClick={() => {
          if (type) {
            setOpenModal(true)
            form.setFieldsValue({
              type: type,
              data: [{ ownerAddress: '', amount: null }],
            })
          }
        }}
      >
        Create
      </ProtectedButton>
      <Modal
        title={'Create User Vesting'}
        open={openModal}
        onOk={handleOk}
        onCancel={handleCancel}
        className="modalStaking"
        width={750}
        centered
        okText={'Create'}
      >
        <Form form={form} style={{ maxWidth: 750 }}>
          <Form.Item name={'type'} hidden={true}>
            <Input disabled />
          </Form.Item>
          <Form.List name="data">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <div
                    key={key}
                    style={{
                      display: 'flex',
                      columnGap: '8px',
                      width: '100%',
                      marginBottom: '16px',
                    }}
                    //align="baseline"
                  >
                    <Form.Item
                      {...restField}
                      name={[name, 'ownerAddress']}
                      style={{ marginBottom: 0, width: '60%' }}
                      rules={[
                        {
                          required: true,
                          message: 'Please input user address!',
                        },
                        {
                          validator(_, value) {
                            if (!value) {
                              return Promise.resolve()
                            }
                            if (isValidETHAddress(value) === false) {
                              return Promise.reject('Invalid Address')
                            }

                            // Lấy danh sách hiện tại trong form
                            const list = form.getFieldValue('data') || []

                            // Đếm số lần xuất hiện của address (không phân biệt hoa/thường)
                            const count = list.filter(
                              (item: any) =>
                                item?.ownerAddress?.toLowerCase() === value?.toLowerCase()
                            ).length

                            if (count > 1) {
                              return Promise.reject('Duplicate address found!')
                            }

                            return Promise.resolve()
                          },
                        },
                      ]}
                    >
                      <Input placeholder="User address" />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'amount']}
                      style={{ marginBottom: 0, width: '35%' }}
                      rules={[
                        {
                          required: true,
                          message: 'Please input allocation!',
                        },
                      ]}
                    >
                      <InputNumber<number>
                        style={{ width: '100%' }}
                        min={0}
                        placeholder={`Enter Allocation`}
                      />
                    </Form.Item>
                    <MinusCircleOutlined onClick={() => remove(name)} />
                  </div>
                ))}
                {/* Giới hạn tối đa 10 bản ghi */}
                {fields.length < 10 ? (
                  <Form.Item>
                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                      Add field
                    </Button>
                  </Form.Item>
                ) : (
                  <div style={{ textAlign: 'center', color: 'red', marginTop: 8 }}>
                    Maximum 10 records allowed.
                  </div>
                )}
              </>
            )}
          </Form.List>
        </Form>
      </Modal>
    </>
  )
}

export default ButtonCreate
